import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  it: {
    // Navigation
    nav: {
      home: 'Home',
      services: 'Servizi',
      boats: 'Vendita',
      gallery: 'Galleria',
      events: 'Eventi',
      partners: 'Collaborazioni',
      contact: 'Contatti',
      quote: 'Richiedi Preventivo'
    },
    // Hero
    hero: {
      subtitle: 'Sul lago per voi dal 1977',
      title: 'Cantiere Nautico Brusa',
      description: 'Dal 1977 sinonimo di innovazione, passione e qualità nel servizio allo sviluppo nautico regionale sul Lago Maggiore.',
      cta: 'Scopri i nostri servizi',
      ctaSecondary: 'Imbarcazioni in stock'
    },
    // Services
    services: {
      title: 'I Nostri Servizi',
      subtitle: 'Esperienza e professionalità al vostro servizio',
      vendita: {
        title: 'Vendita & Showroom',
        description: 'Ampia gamma di yacht esposti con possibilità di prove in acqua per accompagnarvi all\'acquisto del vostro futuro yacht.'
      },
      invernaggio: {
        title: 'Invernaggio & Deposito',
        description: 'Più di 200 posti per curare i vostri yacht durante il periodo invernale. Preparati con cura e alloggiati in sicurezza.'
      },
      trasporto: {
        title: 'Trasporto',
        description: 'Trasporto nazionale e internazionale di qualsiasi tipo di yacht. Organizziamo tutto per farvi godere il vostro acquisto.'
      },
      manutenzione: {
        title: 'Manutenzione',
        description: '12 specialisti al vostro servizio: sistemisti, carrozzieri, esperti di materiali e meccanici certificati.'
      }
    },
    // Boats catalog
    boats: {
      title: 'Imbarcazioni e Yacht in Vendita',
      subtitle: 'Scopri la nostra selezione di imbarcazioni in pronta consegna',
      filter: 'Filtra',
      allBrands: 'Tutti i brand',
      allConditions: 'Tutte le condizioni',
      new: 'Nuovo',
      used: 'Usato',
      length: 'Lunghezza',
      engine: 'Motore',
      year: 'Anno',
      price: 'Prezzo',
      details: 'Dettagli',
      bookVisit: 'Prenota visita',
      noResults: 'Nessuno yacht trovato con questi filtri.'
    },
    // Events
    events: {
      title: 'Prossimi Eventi Nautici',
      subtitle: 'Incontrateci alle fiere più importanti',
      visitWebsite: 'Visita sito'
    },
    // Contact
    contact: {
      title: 'Contattaci',
      subtitle: 'Siamo a vostra disposizione',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefono',
      subject: 'Oggetto',
      message: 'Messaggio',
      send: 'Invia messaggio',
      success: 'Messaggio inviato con successo!',
      error: 'Errore nell\'invio. Riprova.',
      address: 'Indirizzo',
      openHours: 'Orari di apertura',
      weekdays: 'Lun - Ven: 08:00 - 12:00, 13:30 - 18:00',
      saturday: 'Sab: 08:00 - 12:00'
    },
    // Quote form
    quote: {
      title: 'Richiedi Preventivo',
      subtitle: 'Compila il modulo per ricevere un preventivo personalizzato',
      serviceType: 'Tipo di servizio',
      boatInfo: 'Informazioni imbarcazione',
      boatInfoPlaceholder: 'Modello, lunghezza, anno...',
      services: {
        vendita: 'Vendita yacht',
        invernaggio: 'Invernaggio & Deposito',
        trasporto: 'Trasporto',
        manutenzione: 'Manutenzione'
      },
      submit: 'Invia richiesta',
      success: 'Richiesta inviata! Vi contatteremo presto.',
      error: 'Errore nell\'invio. Riprova.'
    },
    // Visit booking
    visit: {
      title: 'Prenota una Visita',
      subtitle: 'Vieni a vedere i nostri yacht dal vivo',
      date: 'Data preferita',
      time: 'Orario preferito',
      type: 'Tipo di visita',
      showroom: 'Visita showroom',
      testDrive: 'Prova in acqua',
      notes: 'Note aggiuntive',
      submit: 'Prenota visita',
      success: 'Prenotazione ricevuta! Vi contatteremo per conferma.',
      error: 'Errore nella prenotazione. Riprova.'
    },
    // Footer
    footer: {
      description: 'Dal 1977 il Cantiere Nautico Brusa sul Lago Maggiore è sinonimo di innovazione e qualità nel servizio nautico.',
      quickLinks: 'Link Rapidi',
      ourServices: 'I Nostri Servizi',
      contact: 'Contatti',
      rights: 'Tutti i diritti riservati.',
      charter: 'Boats Charter Locarno',
      luxury: 'Luxury Yacht Charter'
    },
    // Brands
    brands: {
      title: 'Le Nostre Collaborazioni',
      subtitle: 'Collaboriamo con i migliori marchi e aziende del settore'
    },
    // Gallery
    gallery: {
      title: 'Galleria',
      subtitle: 'Scopri il nostro cantiere e i nostri yacht'
    }
  },
  de: {
    nav: {
      home: 'Home',
      services: 'Dienstleistungen',
      boats: 'Verkauf',
      gallery: 'Galerie',
      events: 'Events',
      partners: 'Kooperationen',
      contact: 'Kontakt',
      quote: 'Angebot anfordern'
    },
    hero: {
      subtitle: 'Seit 1977 auf dem See für Sie',
      title: 'Cantiere Nautico Brusa',
      description: 'Seit 1977 Synonym für Innovation, Leidenschaft und Qualität im nautischen Service am Lago Maggiore.',
      cta: 'Unsere Dienstleistungen',
      ctaSecondary: 'Gebrauchtboote ansehen'
    },
    services: {
      title: 'Unsere Dienstleistungen',
      subtitle: 'Erfahrung und Professionalität zu Ihren Diensten',
      vendita: {
        title: 'Verkauf & Showroom',
        description: 'Große Auswahl an ausgestellten Yachten mit Möglichkeit zur Probefahrt für Ihren zukünftigen Yachtkauf.'
      },
      invernaggio: {
        title: 'Winterlager & Depot',
        description: 'Über 200 Plätze für die Pflege Ihrer Yachten während der Winterzeit. Sorgfältig vorbereitet und sicher untergebracht.'
      },
      trasporto: {
        title: 'Transport',
        description: 'Nationaler und internationaler Transport jeder Art von Yacht. Wir organisieren alles für Sie.'
      },
      manutenzione: {
        title: 'Wartung',
        description: '12 Spezialisten zu Ihren Diensten: Systemtechniker, Karosseriebauer, Materialexperten und zertifizierte Mechaniker.'
      }
    },
    boats: {
      title: 'Boote und Yachten zum Verkauf',
      subtitle: 'Entdecken Sie unsere Auswahl an sofort verfügbaren Booten',
      filter: 'Filter',
      allBrands: 'Alle Marken',
      allConditions: 'Alle Zustände',
      new: 'Neu',
      used: 'Gebraucht',
      length: 'Länge',
      engine: 'Motor',
      year: 'Jahr',
      price: 'Preis',
      details: 'Details',
      bookVisit: 'Besichtigung buchen',
      noResults: 'Keine Yachten mit diesen Filtern gefunden.'
    },
    events: {
      title: 'Kommende Nautik-Events',
      subtitle: 'Treffen Sie uns auf den wichtigsten Messen',
      visitWebsite: 'Website besuchen'
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Wir stehen Ihnen zur Verfügung',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      subject: 'Betreff',
      message: 'Nachricht',
      send: 'Nachricht senden',
      success: 'Nachricht erfolgreich gesendet!',
      error: 'Fehler beim Senden. Bitte erneut versuchen.',
      address: 'Adresse',
      openHours: 'Öffnungszeiten',
      weekdays: 'Mo - Fr: 08:00 - 12:00, 13:30 - 18:00',
      saturday: 'Sa: 08:00 - 12:00'
    },
    quote: {
      title: 'Angebot anfordern',
      subtitle: 'Füllen Sie das Formular für ein persönliches Angebot aus',
      serviceType: 'Art der Dienstleistung',
      boatInfo: 'Boot-Informationen',
      boatInfoPlaceholder: 'Modell, Länge, Jahr...',
      services: {
        vendita: 'Yachtverkauf',
        invernaggio: 'Winterlager & Depot',
        trasporto: 'Transport',
        manutenzione: 'Wartung'
      },
      submit: 'Anfrage senden',
      success: 'Anfrage gesendet! Wir werden Sie bald kontaktieren.',
      error: 'Fehler beim Senden. Bitte erneut versuchen.'
    },
    visit: {
      title: 'Besichtigung buchen',
      subtitle: 'Kommen Sie und sehen Sie unsere Yachten live',
      date: 'Bevorzugtes Datum',
      time: 'Bevorzugte Zeit',
      type: 'Art der Besichtigung',
      showroom: 'Showroom-Besichtigung',
      testDrive: 'Probefahrt',
      notes: 'Zusätzliche Anmerkungen',
      submit: 'Besichtigung buchen',
      success: 'Buchung erhalten! Wir werden Sie zur Bestätigung kontaktieren.',
      error: 'Fehler bei der Buchung. Bitte erneut versuchen.'
    },
    footer: {
      description: 'Seit 1977 ist die Werft Brusa am Lago Maggiore Synonym für Innovation und Qualität im nautischen Service.',
      quickLinks: 'Schnelllinks',
      ourServices: 'Unsere Dienstleistungen',
      contact: 'Kontakt',
      rights: 'Alle Rechte vorbehalten.',
      charter: 'Boats Charter Locarno',
      luxury: 'Luxury Yacht Charter'
    },
    brands: {
      title: 'Unsere Kooperationen',
      subtitle: 'Wir arbeiten mit den besten Marken und Unternehmen der Branche zusammen'
    },
    gallery: {
      title: 'Galerie',
      subtitle: 'Entdecken Sie unsere Werft und unsere Yachten'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      services: 'Services',
      boats: 'Vente',
      gallery: 'Galerie',
      events: 'Événements',
      partners: 'Collaborations',
      contact: 'Contact',
      quote: 'Demander un devis'
    },
    hero: {
      subtitle: 'Sur le lac pour vous depuis 1977',
      title: 'Cantiere Nautico Brusa',
      description: 'Depuis 1977, synonyme d\'innovation, de passion et de qualité dans le service nautique sur le Lac Majeur.',
      cta: 'Découvrir nos services',
      ctaSecondary: 'Voir les occasions'
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Expérience et professionnalisme à votre service',
      vendita: {
        title: 'Vente & Showroom',
        description: 'Large gamme de yachts exposés avec possibilité d\'essais en mer pour vous accompagner dans l\'achat de votre futur yacht.'
      },
      invernaggio: {
        title: 'Hivernage & Dépôt',
        description: 'Plus de 200 places pour prendre soin de vos yachts pendant la période hivernale. Préparés avec soin et logés en sécurité.'
      },
      trasporto: {
        title: 'Transport',
        description: 'Transport national et international de tout type de yacht. Nous organisons tout pour vous.'
      },
      manutenzione: {
        title: 'Maintenance',
        description: '12 spécialistes à votre service: systémiciens, carrossiers, experts en matériaux et mécaniciens certifiés.'
      }
    },
    boats: {
      title: 'Bateaux et Yachts à Vendre',
      subtitle: 'Découvrez notre sélection de bateaux disponibles immédiatement',
      filter: 'Filtrer',
      allBrands: 'Toutes les marques',
      allConditions: 'Toutes les conditions',
      new: 'Neuf',
      used: 'Occasion',
      length: 'Longueur',
      engine: 'Moteur',
      year: 'Année',
      price: 'Prix',
      details: 'Détails',
      bookVisit: 'Réserver une visite',
      noResults: 'Aucun yacht trouvé avec ces filtres.'
    },
    events: {
      title: 'Prochains Événements Nautiques',
      subtitle: 'Rencontrez-nous aux salons les plus importants',
      visitWebsite: 'Visiter le site'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes à votre disposition',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      subject: 'Sujet',
      message: 'Message',
      send: 'Envoyer le message',
      success: 'Message envoyé avec succès!',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.',
      address: 'Adresse',
      openHours: 'Heures d\'ouverture',
      weekdays: 'Lun - Ven: 08:00 - 12:00, 13:30 - 18:00',
      saturday: 'Sam: 08:00 - 12:00'
    },
    quote: {
      title: 'Demander un devis',
      subtitle: 'Remplissez le formulaire pour recevoir un devis personnalisé',
      serviceType: 'Type de service',
      boatInfo: 'Informations sur le bateau',
      boatInfoPlaceholder: 'Modèle, longueur, année...',
      services: {
        vendita: 'Vente de yacht',
        invernaggio: 'Hivernage & Dépôt',
        trasporto: 'Transport',
        manutenzione: 'Maintenance'
      },
      submit: 'Envoyer la demande',
      success: 'Demande envoyée! Nous vous contacterons bientôt.',
      error: 'Erreur lors de l\'envoi. Veuillez réessayer.'
    },
    visit: {
      title: 'Réserver une visite',
      subtitle: 'Venez voir nos yachts en personne',
      date: 'Date préférée',
      time: 'Heure préférée',
      type: 'Type de visite',
      showroom: 'Visite du showroom',
      testDrive: 'Essai en mer',
      notes: 'Notes supplémentaires',
      submit: 'Réserver la visite',
      success: 'Réservation reçue! Nous vous contacterons pour confirmation.',
      error: 'Erreur lors de la réservation. Veuillez réessayer.'
    },
    footer: {
      description: 'Depuis 1977, le chantier naval Brusa sur le Lac Majeur est synonyme d\'innovation et de qualité dans le service nautique.',
      quickLinks: 'Liens Rapides',
      ourServices: 'Nos Services',
      contact: 'Contact',
      rights: 'Tous droits réservés.',
      charter: 'Boats Charter Locarno',
      luxury: 'Luxury Yacht Charter'
    },
    brands: {
      title: 'Nos Collaborations',
      subtitle: 'Nous collaborons avec les meilleures marques et entreprises du secteur'
    },
    gallery: {
      title: 'Galerie',
      subtitle: 'Découvrez notre chantier et nos yachts'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      boats: 'Sales',
      gallery: 'Gallery',
      events: 'Events',
      partners: 'Collaborations',
      contact: 'Contact',
      quote: 'Request Quote'
    },
    hero: {
      subtitle: 'On the lake for you since 1977',
      title: 'Cantiere Nautico Brusa',
      description: 'Since 1977, synonymous with innovation, passion and quality in nautical service on Lake Maggiore.',
      cta: 'Discover our services',
      ctaSecondary: 'View used boats'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Experience and professionalism at your service',
      vendita: {
        title: 'Sales & Showroom',
        description: 'Wide range of displayed yachts with the possibility of sea trials to accompany you in purchasing your future yacht.'
      },
      invernaggio: {
        title: 'Winter Storage & Depot',
        description: 'Over 200 spaces to care for your yachts during the winter period. Carefully prepared and safely stored.'
      },
      trasporto: {
        title: 'Transport',
        description: 'National and international transport of any type of yacht. We organize everything for you.'
      },
      manutenzione: {
        title: 'Maintenance',
        description: '12 specialists at your service: system engineers, bodyworkers, material experts and certified mechanics.'
      }
    },
    boats: {
      title: 'Boats and Yachts for Sale',
      subtitle: 'Discover our selection of boats ready for immediate delivery',
      filter: 'Filter',
      allBrands: 'All brands',
      allConditions: 'All conditions',
      new: 'New',
      used: 'Used',
      length: 'Length',
      engine: 'Engine',
      year: 'Year',
      price: 'Price',
      details: 'Details',
      bookVisit: 'Book visit',
      noResults: 'No yachts found with these filters.'
    },
    events: {
      title: 'Upcoming Nautical Events',
      subtitle: 'Meet us at the most important boat shows',
      visitWebsite: 'Visit website'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We are at your disposal',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      send: 'Send message',
      success: 'Message sent successfully!',
      error: 'Error sending. Please try again.',
      address: 'Address',
      openHours: 'Opening Hours',
      weekdays: 'Mon - Fri: 08:00 - 12:00, 13:30 - 18:00',
      saturday: 'Sat: 08:00 - 12:00'
    },
    quote: {
      title: 'Request Quote',
      subtitle: 'Fill out the form to receive a personalized quote',
      serviceType: 'Service type',
      boatInfo: 'Boat information',
      boatInfoPlaceholder: 'Model, length, year...',
      services: {
        vendita: 'Yacht sales',
        invernaggio: 'Winter storage & Depot',
        trasporto: 'Transport',
        manutenzione: 'Maintenance'
      },
      submit: 'Submit request',
      success: 'Request sent! We will contact you soon.',
      error: 'Error sending. Please try again.'
    },
    visit: {
      title: 'Book a Visit',
      subtitle: 'Come and see our yachts in person',
      date: 'Preferred date',
      time: 'Preferred time',
      type: 'Visit type',
      showroom: 'Showroom visit',
      testDrive: 'Sea trial',
      notes: 'Additional notes',
      submit: 'Book visit',
      success: 'Booking received! We will contact you for confirmation.',
      error: 'Error booking. Please try again.'
    },
    footer: {
      description: 'Since 1977, Brusa Shipyard on Lake Maggiore has been synonymous with innovation and quality in nautical service.',
      quickLinks: 'Quick Links',
      ourServices: 'Our Services',
      contact: 'Contact',
      rights: 'All rights reserved.',
      charter: 'Boats Charter Locarno',
      luxury: 'Luxury Yacht Charter'
    },
    brands: {
      title: 'Our Collaborations',
      subtitle: 'We collaborate with the best brands and companies in the industry'
    },
    gallery: {
      title: 'Gallery',
      subtitle: 'Discover our shipyard and our yachts'
    }
  }
};

const LanguageContext = createContext();

// Detect browser/system language
const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0].toLowerCase();
  
  // Map browser language to supported languages
  const supportedLangs = ['it', 'de', 'fr', 'en'];
  if (supportedLangs.includes(langCode)) {
    return langCode;
  }
  
  // Default to Italian if language not supported
  return 'it';
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // First check localStorage for saved preference
    const saved = localStorage.getItem('brusa-language');
    if (saved) return saved;
    
    // Otherwise detect browser language
    return detectBrowserLanguage();
  });

  useEffect(() => {
    localStorage.setItem('brusa-language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
